module.exports = __webpack_public_path__ + "img/16.2f2188b9.svg";